import { cn } from 'src/shared/utils/cn'

interface DotListProps {
  items: (string | null | undefined)[]
  textClassName?: string
  dotText?: string
}

export default function DotList({ items, textClassName, dotText = '•' }: DotListProps) {
  const filteredItems = items.filter(Boolean)

  return (
    <div>
      {filteredItems.map((item, index) => {
        return (
          <span key={index}>
            <span className={cn('text-sm text-muted', textClassName)}>{item}</span>
            {index !== filteredItems.length - 1 && (
              <span className="inline-block px-1 text-sm text-muted">{dotText}</span>
            )}
          </span>
        )
      })}
    </div>
  )
}
